/**
 * Created by Jerker Nord on 2019-09-02.
 */
import {ITextStyles} from "./ITextStyles";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class BonusBunniesDesktopTextStyles implements ITextStyles {

    private static _instance:BonusBunniesDesktopTextStyles = new BonusBunniesDesktopTextStyles();

    static get instance():BonusBunniesDesktopTextStyles {
        return this._instance;
    }

    constructor() {
        if(BonusBunniesDesktopTextStyles._instance) {
            throw new Error("Error: ThorDesktopTextStyles.constructor() - Instantiation failed: Use ThorDesktopTextStyles.instance instead of new.");
        }
    }

    COUNTUP_YELLOW_BITMAP_STYLE:BitmapTextStyleOptions = {
        font : {
            name : "winNumbers",
            size : 130
        }
    };

    B5_WIN_BITMAP_STYLE:BitmapTextStyleOptions = {
        font : {
            name : "winNumbers",
            size : 50
        }
    };

    // Bitmap font for number of FS in main game
    FS_WIN_NUMBER:BitmapTextStyleOptions = {
        font : {
            name : "winNumbers",
            size : 9
        }
    };

    MULTIPLIER_TEXT_STYLE:BitmapTextStyleOptions = {
        font : {
            name : "winNumbers",
            size : 54
        }
    };

    MULTIPLIER_COUNTER_BITMAP_STYLE:BitmapTextStyleOptions = {
        font : {
            name : "winNumbers",
            size : 55
        }
    };

    SCATTER_COUNTER_TEXT_STYLE:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "50px",
        fill : "#000000",
        fontStyle : FontStyle.NORMAL,
        fontWeight: FontWeight.BOLD
    };

    FREESPIN_INTRO_YOU_WON:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "50px",
        fill : "#e4e1c8",
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.BOLD,
        dropShadow : true,
        dropShadowAlpha : 1,
        dropShadowAngle : Math.PI * 0.5,
        dropShadowBlur : 8,
        dropShadowColor : "#000000",
        dropShadowDistance : 3,
        padding : 20
    };

    FREESPIN_INTRO_NUMBER:BitmapTextStyleOptions = {
        font : {
            name : "winNumbers",
            size : 50
        }
    };

    FREESPIN_OUTRO_YOU_WON:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "50px",
        fill : "0xedc19e",
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.BOLD,
        dropShadow : true,
        dropShadowAlpha : 1,
        dropShadowAngle : Math.PI * 0.5,
        dropShadowBlur : 8,
        dropShadowColor : "#000000",
        dropShadowDistance : 3,
        padding : 20
    };

    FREESPIN_OUTRO_NUMBER:BitmapTextStyleOptions = {
        font : {
            name : "winNumbers",
            size : 85
        }
    };

    FREESPIN_OUTRO_SPINS_PLAYED:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "30px",
        fill : "0xedc19e",
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.BOLD,
        dropShadow : true,
        dropShadowAlpha : 1,
        dropShadowAngle : Math.PI * 0.5,
        dropShadowBlur : 8,
        dropShadowColor : "#000000",
        dropShadowDistance : 3,
        padding : 20
    };
}